export const findTourPackageDashboard = (dashboards = []) => {
  if (!Array.isArray(dashboards)) {
    return null;
  }

  return (
    dashboards.find((dashboard) => dashboard?.name === "TourPackage") ||
    dashboards.find((dashboard) => dashboard?.route === "tourPackage") ||
    null
  );
};

const getZoneId = (zone) => {
  if (!zone) {
    return null;
  }

  if (typeof zone === "string") {
    return zone;
  }

  if (typeof zone.id === "string") {
    return zone.id;
  }

  if (typeof zone._id === "string") {
    return zone._id;
  }

  if (typeof zone._id?.$oid === "string") {
    return zone._id.$oid;
  }

  return null;
};

const normalizePoint = (point) => {
  const latitude = Number(point?.latitude);
  const longitude = Number(point?.longitude);

  if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
    return null;
  }

  return { latitude, longitude };
};

export const getTourPackagePickupZoneIds = (dashboards = []) => {
  const tourPackageDashboard = findTourPackageDashboard(dashboards);
  const pickupInclusiveZones =
    tourPackageDashboard?.zoneConfiguration?.pickup?.inc || [];

  if (!Array.isArray(pickupInclusiveZones)) {
    return [];
  }

  return pickupInclusiveZones.map(getZoneId).filter(Boolean);
};

export const getTourPackagePickupPolygons = (dashboards = [], zones = []) => {
  const tourPackageDashboard = findTourPackageDashboard(dashboards);
  const pickupInclusiveZones =
    tourPackageDashboard?.zoneConfiguration?.pickup?.inc || [];

  if (!Array.isArray(pickupInclusiveZones)) {
    return [];
  }

  const zoneMap = new Map(
    (Array.isArray(zones) ? zones : [])
      .map((zone) => [getZoneId(zone), zone])
      .filter(([id]) => Boolean(id)),
  );

  return pickupInclusiveZones
    .map((zone) => (typeof zone === "string" ? zoneMap.get(zone) : zone))
    .filter((zone) => zone?.isEnabled !== false && Array.isArray(zone?.points))
    .map((zone) => zone.points.map(normalizePoint).filter(Boolean))
    .filter((polygon) => polygon.length >= 3);
};
